import api from './api';
export const customersAPI = {
  list: () => api.get('/customers'),
  get: id => api.get(`/customers/${id}`),
  create: data => api.post('/customers', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  addContact: (id, data) => api.post(`/customers/${id}/contacts`, data),
  updateContact: (id, contactId, data) => api.put(`/customers/${id}/contacts/${contactId}`, data),
};
export const customFieldsAPI = {
  list: () => api.get('/custom-fields'),
  create: data => api.post('/custom-fields', data),
  update: (id, data) => api.put(`/custom-fields/${id}`, data),
  remove: id => api.delete(`/custom-fields/${id}`),
};
